import React, {Component} from 'react'
import './OrderMarker.scss'
import chroma from "chroma-js";
import moment from 'moment';
import {buildStyles, CircularProgressbar} from "react-circular-progressbar";
import CircularProgress from "@material-ui/core/CircularProgress";
import {getTillLate} from "../../../../Orders/OrdersGrid/TimeTillArrivalProgressbar/TimeTillArrivalProgressbar";
import PlacesOfDepartureImages from "../../../../../Utils/PlacesOfDepartureImages";
import {eventsSubject} from "../../../../../Events/events";
import {filter} from "rxjs/operators";
import {FocusOrdersInMap} from "../../../../../Events/topics";

export default class OrderMarker extends Component {
    constructor(props) {
        super(props);

        this.percentColors = chroma.scale(['ForestGreen', "#CCCC00", 'Crimson']).colors(101);

        this.state = {
            passedTime: moment(new Date(props.order.orderTime)).fromNow()
        };

        const tillLate = getTillLate(props.proposedDeliveryGroups, props.order);

        if (tillLate) {
            this.state.percentTillLate = tillLate.percentTillLate;
            this.state.minutesTillProposedArrival = tillLate.minutesTillProposedArrival;
        }

        const label = this.getOrderMapLabel(props.proposedDeliveryGroups, props.assignedDeliveryGroups, props.order);

        if (label)
            this.state.orderLabel = label

        this.focusOrdersInMapSubscription = eventsSubject
            .pipe(filter(f => f.topic === FocusOrdersInMap))
            .subscribe(data => this.onFocusOrdersInMap(data));

        this.markerRef = React.createRef();
    }

    setMarkerClassNameIfExists(className) {
        const element = document.getElementById(`order-marker-${this.props.order.id}`);

        if (element)
            element.className = className;
    }

    setMakerClass(className) {
        const element = document.getElementById(`order-marker-${this.props.order.id}`);

        if (element)
            element.className = className;
    }

    setMarkerFading(isFaded) {
        if (isFaded !== this.isFaded) {
            let markerClass = 'order-marker';

            if (isFaded)
                markerClass += ' order-marker-faded';

            this.setMakerClass(markerClass);
            this.isFaded = isFaded;
        }
    }

    onFocusOrdersInMap(m) {
        if (m.data)
            this.setMarkerFading(!m.data.includes(this.props.order.id));
        else if (this.isFaded)
            this.setMarkerFading(false);
    }

    componentDidMount() {
        this.startTimer();
    }

    componentWillUnmount() {
        this.focusOrdersInMapSubscription.unsubscribe();
        this.stopTimer();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            passedTime: moment(new Date(nextProps.order.orderTime)).fromNow(),
        });

        const tillLate = getTillLate(nextProps.proposedDeliveryGroups, nextProps.order);

        if (tillLate) {
            this.setState({
                percentTillLate: tillLate.percentTillLate,
                minutesTillProposedArrival: tillLate.minutesTillProposedArrival
            });
        }

        const label = this.getOrderMapLabel(nextProps.proposedDeliveryGroups, nextProps.assignedDeliveryGroups, nextProps.order);

        if (label) {
            this.setState({
                orderLabel: label
            });
        }
    }

    getDeliveryGroupsForOrder(proposedDeliveryGroups, assignedDeliveryGroups, order) {
        if (["READY", "SCHEDULED_READY"].includes(order.status))
            return proposedDeliveryGroups;
        else if (["ASSIGNED_SCHEDULED_READY", "ASSIGNED", "COLLECTED", "SENT", "DELIVERED"].includes(order.status))
            return assignedDeliveryGroups;

        return null;
    }

    startTimer() {
        if (!this.timerId) {
            this.timerId = setInterval(() => this.timerContent(this.props), 1000);
        }
    }

    stopTimer() {
        clearInterval(this.timerId);
    }

    timerContent(props) {
        this.setState({
            passedTime: moment(new Date(props.order.orderTime)).fromNow()
        });

        const tillLate = getTillLate(props.proposedDeliveryGroups, props.order);

        if (tillLate) {
            this.setState({
                percentTillLate: tillLate.percentTillLate,
                minutesTillProposedArrival: tillLate.minutesTillProposedArrival
            });
        }
    }

    findOrderSendProposal(deliveryGroups, order) {
        for (let groupIndex = 0; groupIndex < deliveryGroups.length; groupIndex++) {
            const group = deliveryGroups[groupIndex];

            for (let orderIndex = 0; orderIndex < group.route.length; orderIndex++) {
                const orderInRoute = group.route[orderIndex];

                if (orderInRoute.order_id === order.id) {
                    return {
                        group: group,
                        orderInRoute: orderInRoute,
                        orderIndexInRoute: orderIndex
                    }
                }
            }
        }

        return null;
    }

    getOrderMapLabel(proposedDeliveryGroups, assignedDeliveryGroups, order) {
        const deliveryGroupsForLabel = this.getDeliveryGroupsForOrder(proposedDeliveryGroups, assignedDeliveryGroups, order);

        if (!deliveryGroupsForLabel)
            return "";

        const foundOrderInGroup = this.findOrderSendProposal(deliveryGroupsForLabel, order);

        if (foundOrderInGroup)
            return (foundOrderInGroup.orderIndexInRoute + 1).toString();

        return "";
    }

    render() {
        let alertPie;

        if (this.props.order.status === 'READY') {
            if (this.props.evaluatingProposedDeliveryGroups) {
                alertPie = <span className="order-marker-label-circle"><CircularProgress size={22} thickness={6}
                                                                                         disableShrink/></span>
            } else if (this.state.percentTillLate) {
                alertPie = <CircularProgressbar
                    className={`order-marker-label-circle ${(this.props.order.sla - this.state.minutesTillProposedArrival) < 15 ? 'blinker-full' : ''}`}
                    value={this.state.percentTillLate}
                    strokeWidth={16}
                    styles={buildStyles({
                        backgroundColor: 'LightGray',
                        pathColor: this.percentColors[Math.floor(this.state.percentTillLate)],
                        strokeLinecap: "butt",
                        stroke: 'black'
                    })}/>;
            }
        } else if (this.props.readySla !== undefined && this.props.readySla !== null && this.props.order.status === 'ACCEPTED' && moment.duration(moment().diff(moment(new Date(this.props.order.orderTime)))).asMinutes() >= this.props.readySla) {
            alertPie = <CircularProgressbar className={`order-marker-label-circle blinker-full`}
                                            value={100}
                                            strokeWidth={50}
                                            styles={buildStyles({
                                                backgroundColor: 'LightGray',
                                                pathColor: '#ffff00',
                                                strokeLinecap: "butt",
                                                stroke: 'black'
                                            })}/>;
        }

        return (
            <div id={`order-marker-${this.props.order.id}`} className={`order-marker`}
                 ref={this.markerRef}>
                <div className="order-marker-icon">
                    {React.cloneElement(this.props.pinIcon, {width: "31.85px", height: "48.93"})}
                </div>
                <div className="order-marker-label-circle" style={{backgroundColor: this.props.innerColor}}/>
                {alertPie}
                <div className="order-marker-label">
                    {this.state.orderLabel}
                </div>
                {
                    this.props.placesOfDeparture && this.props.order.placeOfDeparture ? (() => {
                            const placeOfDepartureImagePngBytes = PlacesOfDepartureImages.getImage(this.props.order.placeOfDeparture);

                            if (placeOfDepartureImagePngBytes)
                                return (
                                    <div className="order-marker-place-of-departure">
                                        <img className="order-marker-place-of-departure-image"
                                             src={`data:image/png;base64,${placeOfDepartureImagePngBytes}`}/>
                                    </div>
                                );

                            return (
                                <div className="order-marker-place-of-departure">
                                    {this.props.order.placeOfDeparture}
                                </div>
                            );
                        })()
                        :
                        null
                }
            </div>
        )
    }
}